import { render, staticRenderFns } from "./VideosCategories.vue?vue&type=template&id=d1a35022&scoped=true&"
import script from "./VideosCategories.vue?vue&type=script&lang=js&"
export * from "./VideosCategories.vue?vue&type=script&lang=js&"
import style0 from "./VideosCategories.vue?vue&type=style&index=0&id=d1a35022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a35022",
  null
  
)

export default component.exports